<template>
  <div class="session-template-manager">
    <div class="page-header">
      <div>
        <h1>{{ $t('bo.sessionTemplates.title') }}</h1>
        <p>{{ $t('bo.sessionTemplates.subtitle') }}</p>
      </div>
      <button @click="showCreate = true" class="btn-primary">
        {{ $t('bo.sessionTemplates.newTemplate') }}
      </button>
    </div>

    <SessionTemplateList ref="listRef" @edit="handleEdit" @view="handleView" />

    <CreateSessionTemplate
      v-if="showCreate"
      @close="showCreate = false"
      @created="handleCreated"
    />

    <EditSessionTemplate
      v-if="editingId"
      :template-id="editingId"
      @close="editingId = null"
      @updated="handleUpdated"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import SessionTemplateList from './SessionTemplateList.vue'
import CreateSessionTemplate from './CreateSessionTemplate.vue'
import EditSessionTemplate from './EditSessionTemplate.vue'

const showCreate = ref(false)
const editingId = ref(null)
const listRef = ref(null)

const handleEdit = (id) => {
  editingId.value = id
}

const handleView = (id) => {
  editingId.value = id
}

const handleCreated = () => {
  showCreate.value = false
  listRef.value?.loadTemplates()
}

const handleUpdated = () => {
  editingId.value = null
  listRef.value?.loadTemplates()
}
</script>

<style scoped>
.session-template-manager {
  padding: 2rem;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem;
}

.page-header p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

.btn-primary {
  padding: 0.625rem 1.25rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.875rem;
  transition: background 0.2s;
  white-space: nowrap;
}

.btn-primary:hover {
  background: #2563eb;
}
</style>
